/**
 * Location Autocomplete, a Bootstrap 3 typeahead + Google Places Autocomplete component
 * Author: Chris Roby
 * Copyright: © 2014 A Place For Rover, Inc.
 * License: MIT
 *
 * Dependencies:
 *  - jQuery
 *  - typeahead.js for Bootstrap 3 (https://github.com/bassjobsen/Bootstrap-3-Typeahead)
 *  - Google Maps
        (<script src="//maps.google.com/maps/api/js?sensor=true&amp;libraries=places"></script>)
 */

import inject from '@rover/utilities/injector';
import Maps from './maps';

(function($) {
  $.fn.locationpicker = function(options) {
    options = options || {};

    if (options.types) {
      options.types = options.types.split(',');
    }

    options = $.extend(
      {},
      {
        showGoogleLogo: true,
        types: ['geocode'],
        resultLinkClasses: '',
        autoSelect: false,
        truncateCountry: false,
        onlyNonNumeric: false,
        $triggers: false,
        $lat: false,
        $lng: false,
      },
      options
    );

    const getDisplayNameFromAutocompleteResult = function({ description }) {
      if (options.truncateCountry) {
        const lastCommaIndex = description.lastIndexOf(',');
        return lastCommaIndex === -1 ? description : description.substring(0, lastCommaIndex);
      }
      return description;
    };

    const sortResults = function(results) {
      return results;
    };

    const getPlacePredictions = function(query, callback) {
      if (options.onlyNonNumeric && !query.match(/[^0-9]+/)) {
        callback([]);
        return;
      }
      const data = {
        input: query || ' ',
        types: options.types,
      };

      const autocompletionCountryRestrictions = inject(
        'Rover.context.autocompletionCountryRestrictions',
        null
      );
      if (autocompletionCountryRestrictions) {
        data.componentRestrictions = {
          country: autocompletionCountryRestrictions,
        };
      }

      Maps.getPlacePredictions(data, (predictions, status) => {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          callback($.map(predictions, getDisplayNameFromAutocompleteResult));
        }
      });
    };

    const reverseGeocodeAddress = function(address, callback) {
      const region = inject('Rover.context.ccTLD', 'US');
      Maps.geocode({ address, region }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          let lat = results[0].geometry.location.lat(),
            lng = results[0].geometry.location.lng();
          callback(lat, lng);
        }
      });
    };

    return this.each(function() {
      const $this = $(this);

      $this.attr('autocomplete', 'off');

      $this.typeahead({
        item: `<li><a class="${options.resultLinkClasses}" href="#"></a></li>`,
        source: getPlacePredictions,
        autoSelect: options.autoSelect,
        sorter: sortResults,
        matcher(item) {
          const queryWithoutSpaces = this.query.replace(/ /g, '');
          const itemWithoutSpaces = item.replace(/ /g, '');
          return ~itemWithoutSpaces.toLowerCase().indexOf(queryWithoutSpaces.toLowerCase());
        },
        select() {
          $.fn.typeahead.Constructor.prototype.select.call(this);
          $this.trigger('typeahead:selected');
        },
      });

      if (options.$triggers) {
        options.$triggers.on('click', e => {
          e.preventDefault();
          // Trigger a keyup to show the typeahead
          const evt = $.Event('keyup', { which: 39 });
          $this.focus().trigger(evt);
        });
      }

      if (options.$lat && options.$lng) {
        $this.on('change', function() {
          const address = $(this)
            .val()
            .trim();
          reverseGeocodeAddress(address, (lat, lng) => {
            options.$lat.val(lat);
            options.$lng.val(lng);
          });
        });
      }

      if (options.showGoogleLogo) {
        $this.addClass('showgoogle');
      }

      return this;
    });
  };
})(jQuery);

$(() => {
  $('.locationpicker').each(function() {
    const OPTIONNAMESPACE = 'lp';

    let $this = $(this),
      options = {};

    // strip out the namespacing
    $.each($this.data(), (key, value) => {
      if (key.slice(0, OPTIONNAMESPACE.length) === OPTIONNAMESPACE) {
        key = key.slice(2);
        key = key.charAt(0).toLowerCase() + key.slice(1);
        options[key] = value;
      }
    });

    if ($this.closest('[data-lp-trigger]').length) {
      options.$triggers = $this.closest('[data-lp-trigger]');
    }

    let $lat = $this.siblings('[data-lp-lat]'),
      $lng = $this.siblings('[data-lp-lng]');

    if ($lat.length && $lng.length) {
      options.$lat = $lat;
      options.$lng = $lng;
    }

    $this.locationpicker(options);
  });
});



// WEBPACK FOOTER //
// ./js/components/jquery.locationpicker.js